import React, { Component } from 'react';
import { Link } from 'gatsby';
import './MixedNavigation.scss';

const LINK_TYPE_DOCUMENT = 'Document';
const LINK_TYPE_WEB = 'Web';

const getLink = (link, linkLabel) => {
  const {
    linkType,
    url,
  } = link;
  switch (linkType) {
    case (LINK_TYPE_DOCUMENT):
      return (
        <Link
          to={`${url}/`}
          aria-label={`Navigate to ${linkLabel.text} page`}
        >
          <span>{linkLabel.text}</span>
          <svg className="arrow" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
          </svg>
        </Link>
      );
    case (LINK_TYPE_WEB):
      return (
        <a
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={`Navigate to ${linkLabel.text} page`}
        >
          <span>{linkLabel.text}</span>
          <svg className="arrow" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
          </svg>
        </a>
      );
    default:
      return null;
  }
};


class MixedNavigation extends Component {
  render() {
    const {
      navigation,
    } = this.props;
    return (
      <nav className="mixed-navigation-list" role="navigation">
        <div className="nav-container">
          <ul className="nav-items">
            {navigation.map((item) => {
              const {
                navigationLink,
                navigationLabel,
              } = item;
              return (
                <li className="nav-item" key={navigationLink.url}>
                  {getLink(navigationLink, navigationLabel)}
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    );
  }
}

export default MixedNavigation;
